import { CSSProperties } from 'react';

export const imageStyle: CSSProperties = {
  height: '5.188rem',
  width: '100%',
  position: 'absolute',
  right: '0',
  top: '0',
  bottom: '0',
  left: '0',
  overflow: 'hidden',
  borderRadius: '10px 0px 0px 10px',
};
